import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../../assets/images/logo-2.png'


const _hoisted_1 = { class: "system-header" }
const _hoisted_2 = { class: "flex-align" }
const _hoisted_3 = { class: "schoole-name" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/no_img.png",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "user-menus-box" }
const _hoisted_6 = { class: "user-info" }
const _hoisted_7 = { class: "list-box font16 text_overflow1" }
const _hoisted_8 = { class: "list-box font-color--info text_overflow1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-office-building common_mgr4 font16" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("机构信息 ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-user common_mgr4 font16" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("个人信息 ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "list-box-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-left common_mgr4 font16" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("切换机构 ")
const _hoisted_18 = {
  key: 0,
  class: "item-menus-box"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "icon-active el-icon-check"
}
const _hoisted_21 = { class: "list-box-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-left common_mgr4 font16" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("切换校区 ")
const _hoisted_24 = {
  key: 0,
  class: "item-menus-box"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "icon-active el-icon-check"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-switch-button common_mgr4 font16" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("清除督导视角缓存 ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-switch-button common_mgr4 font16" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode("退出登录 ")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_avatar, {
        size: 50,
        src: _ctx.schooleinfo.logo,
        onError: _ctx.errorHandler,
        class: "common_mgr8"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotowelcome && _ctx.gotowelcome(...args))),
            alt: ""
          })
        ]),
        _: 1
      }, 8, ["src", "onError"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.schooleinfo.name) + " " + _toDisplayString(_ctx.otherTile.length>0?_ctx.otherTile:''), 1)
    ]),
    _createElementVNode("div", {
      class: "user-menu",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isMenus = true))
    }, [
      _createVNode(_component_el_avatar, {
        size: 50,
        src: _ctx.userInfo.avatar,
        onError: _ctx.errorHandler,
        class: "pointer"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["src", "onError"]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.userInfo && _ctx.userInfo.username ? _ctx.userInfo.username : "") + " | " + _toDisplayString(_ctx.getRoleName(_ctx.userInfo&&_ctx.userInfo.role?_ctx.userInfo.role:null)), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.userInfo && _ctx.userInfo.email ? _ctx.userInfo.email : ""), 1)
        ]),
        _createElementVNode("div", {
          class: "list-box-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCommand('/AccountInfo/agencyInfo')))
        }, _hoisted_11),
        _createElementVNode("div", {
          class: "list-box-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleCommand('/AccountInfo/personalSettings')))
        }, _hoisted_14),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          (_ctx.agencyList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencyList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "list-box-item text_overflow1",
                    key: item.coid,
                    onClick: ($event: any) => (_ctx.switchAgencyManage(item))
                  }, [
                    _createTextVNode(_toDisplayString(item.collegeName), 1),
                    (_ctx.schooleinfo.coid == item.coid)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_19))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          (_ctx.campusList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campusList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "list-box-item text_overflow1",
                    key: item.id,
                    onClick: ($event: any) => (_ctx.switchCampus(item))
                  }, [
                    _createTextVNode(_toDisplayString(item.title), 1),
                    (_ctx.userInfo.campusid == item.id)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_25))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "list-box-item",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearSupervisorData()))
        }, _hoisted_29),
        _createElementVNode("div", {
          class: "list-box-item",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleCommand('/login')))
        }, _hoisted_32)
      ], 512), [
        [_vShow, _ctx.isMenus]
      ])
    ])
  ]))
}